import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { InView } from "react-intersection-observer";
// TODO Prevents upgrade to React v17.x
import Ad from "react-google-publisher-tag";
import { Row, Col } from "reactstrap";
import EventCard from "../../event-card/components/event-card";
import eventPropType from "../../../prop-types/event";
import {
  GPT_LIST_DIMENSIONS,
  MOBILE_BREAKPOINT,
  XL_BREAKPOINT
} from "../../../constants";
import { randomId, hasChangedLayout } from "../../../utils/util";

const propTypes = {
  tabName: PropTypes.string.isRequired,
  chunkEvents: PropTypes.arrayOf(PropTypes.arrayOf(eventPropType)),
  width: PropTypes.number.isRequired,
  withAds: PropTypes.bool.isRequired,
  filteredEvents: PropTypes.arrayOf(eventPropType).isRequired,
  isGeoEnabled: PropTypes.bool.isRequired,
  logoUrl: PropTypes.string
};

const defaultProps = {
  chunkEvents: [],
  logoUrl: ""
};

class EventsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: -1,
      eventsToRender: []
    };
  }

  componentDidUpdate(prevProps) {
    const { filteredEvents: prevFilteredEvents, width: prevWidth } = prevProps;
    const { filteredEvents, width } = this.props;
    if (
      !_.isEqual(prevFilteredEvents, filteredEvents) ||
      hasChangedLayout(prevWidth, width)
    ) {
      this.setState(
        {
          eventsToRender: []
        },
        () => {
          this.nextChunk(0);
        }
      );
    }
  }

  nextChunk = (page) => {
    const { chunkEvents, tabName, width, withAds, logoUrl, isGeoEnabled } =
      this.props;
    const { eventsToRender } = this.state;
    if (chunkEvents && !_.isEmpty(chunkEvents) && chunkEvents.length > page) {
      const newEvents =
        chunkEvents[page].map((e, idx) => {
          const adIdx = page * 50 + idx;
          let divisor;
          if (width >= XL_BREAKPOINT) {
            divisor = 8;
          } else {
            divisor = width >= MOBILE_BREAKPOINT ? 6 : 4;
          }
          return (
            <Fragment
              key={`in-view-page-${page}-${tabName}-idx-${e?.id}-${randomId()}`}
            >
              {withAds && adIdx > 0 && adIdx % divisor === 0 && (
                <Row className="ad-container">
                  <Col
                    xs={12}
                    sm={10}
                    className="p-0 pr-1 justify-content-center"
                  >
                    <Ad
                      path="/1025241/PS_WEB"
                      format="HORIZONTAL"
                      dimensions={GPT_LIST_DIMENSIONS}
                      targeting={{ test: "infinitescroll" }}
                      fluid
                      enableSingleRequest
                      collapseEmpty
                    />
                  </Col>
                </Row>
              )}
              <EventCard
                item={e}
                logoUrl={logoUrl}
                isGeoEnabled={isGeoEnabled}
              />
            </Fragment>
          );
        }) || [];
      this.setState({
        page,
        eventsToRender: newEvents.length
          ? [...eventsToRender, ...newEvents]
          : eventsToRender
      });
    }
  };

  render() {
    const { page, eventsToRender } = this.state;
    return (
      <div className="events-list-content w-100">
        {!_.isEmpty(eventsToRender) && eventsToRender}
        <InView
          as="div"
          threshold={0.05}
          rootMargin="270px"
          onChange={(inView) => {
            if (inView || page === -1) {
              this.nextChunk(page + 1);
            }
          }}
        >
          <div className="observer-breakpoint" />
        </InView>
      </div>
    );
  }
}

EventsList.propTypes = propTypes;
EventsList.defaultProps = defaultProps;

export default EventsList;
